export const settings = {
    header: "إعدادات",
    items: {
        motion: {
            label: "انخفاض الحركة",
        },
        contrast: {
            label: "وضع التباين العاليs",
        },
    },
};
